import * as React from 'react';
export const rateCardSvg = React.forwardRef(function rateCardSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.571.3C10.361.3 11 .94 11 1.729V10.3l-.008.146a1.428 1.428 0 0 1-1.274 1.275l-.147.008H2.43l-.147-.008A1.428 1.428 0 0 1 1 10.3V1.729C1 .989 1.562.38 2.282.308L2.43.3h7.14ZM5 10.529h4.571A.229.229 0 0 0 9.8 10.3V8.5H5v2.029ZM2.2 10.3c0 .126.102.229.229.229h1.37V8.5H2.2v1.8Zm2.8-3h4.8V5H5v2.3Zm-2.8 0h1.6V5H2.2v2.3ZM5 3.8h4.8V1.729a.228.228 0 0 0-.23-.229H5v2.3ZM2.429 1.5a.228.228 0 0 0-.229.229V3.8h1.6V1.5H2.429Z',
    }),
  );
});
rateCardSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var rateCard = {
  category: 'icon',
  colorable: true,
  name: 'rateCard',
  svg: rateCardSvg,
};
